var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"text-primary item-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.open.apply(null, arguments)}}},[_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.rowData.name))]),_vm._v(" "),(_vm.rowData.upc)?_c('small',{staticClass:"d-block text-muted"},[_vm._v("#"+_vm._s(_vm.rowData.upc))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }